import React from "react";
import { SEO } from "@bluefin/components";
import { Grid, Segment, Embed } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class VirtualTourPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.emilianobreitsalon.com/virtual-tour/"}
        />
        <Grid
          className={"custom-page-virtual-tour custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"ihjnjenlhdjfeihg"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"ammgfdeiojmpecnm"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__0d2c0f52-3871-43f7-99fc-e93336e7a556"}
                >
                  <Embed
                    url={
                      "https://www.google.com/maps/embed?pb=!4v1763070319394!6m8!1m7!1sCAoSHENJQUJJaEFZeFVuOG04M0VaQUVjYWZsZDVtSHE.!2m2!1d25.74777545844664!2d-80.25837665957559!3f97.8914271821857!4f-4.514546730194468!5f0.7820865974627469"
                    }
                    autoplay={true}
                    defaultActive={true}
                    className={"virtual-tour"}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 35205 }) {
      title
      seoTitle
      description
    }
  }
`;
